<script lang="ts">
    import { CustomLine, type CustomComponentProps } from "svelte-inspect-value";
    import { type BigNumber } from "@repo/utils";
    import Number from "./number.svelte";

    type Props = CustomComponentProps<BigNumber, "bignumber">;

    let { value, ...rest }: Props = $props();
</script>

<CustomLine {value} {...rest}>
    <Number {value} options={{}} />
</CustomLine>
